import type { Components, CssVarsTheme } from '@mui/material/styles';

const defaultProps: NonNullable<
  Components<CssVarsTheme>['MuiDataGrid']
>['defaultProps'] = {
  slotProps: {
    baseButton: { material: { variant: 'contained', color: 'inherit' } },
    baseTextField: {
      material: { variant: 'outlined', size: 'small', style: { padding: '0' } },
    },
  },
};

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiDataGrid']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    borderColor: theme.vars.palette.divider,

    '.MuiDataGrid-container--top [role=row]': {
      backgroundColor: theme.vars.palette.background.paper,
    },

    '.MuiDataGrid-columnHeaders': {
      borderColor: theme.vars.palette.divider,
    },

    '.MuiDataGrid-columnHeaderTitleContainerContent': {
      marginRight: 3,
    },

    '.MuiDataGrid-cell, .MuiDataGrid-withBorderColor': {
      borderColor: theme.vars.palette.divider,
    },

    '.MuiDataGrid-cell, .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': {
        outline: 'none',
      },
      '&:focus-visible': {
        outline: `1px solid ${theme.vars.palette.primary.main}`,
      },
    },

    '.MuiDataGrid-row': {
      transition: '0.2s',
    },

    '.MuiButtonBase-root': {
      border: 'none',
    },

    '.MuiDataGrid-detailPanel': {
      borderBottom: `1px solid ${theme.vars.palette.divider}`,
      backgroundColor: theme.vars.palette.divider,
    },

    '.MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer .MuiIconButton-root':
      {
        fontSize: '1em',
        boxShadow: 'none',
        border: 0,
        outline: 0,
      },

    '.MuiDataGrid-columnHeader--sorted .MuiDataGrid-sortIcon': {
      color: theme.palette.primary.main,
    },

    '.MuiDataGrid-cell .MuiFormControl-root.MuiTextField-root.MuiInputBase-sizeSmall .MuiInputBase-root.MuiOutlinedInput-root':
      {
        padding: theme.spacing(1),
      },

    '.MuiDataGrid-cell > .MuiChip-root > .MuiChip-label': {
      overflow: 'auto',
      textOverflow: 'unset',
    },
  }),
};

const MuiDataGrid: Components<CssVarsTheme>['MuiDataGrid'] = {
  defaultProps,
  styleOverrides,
};

export default MuiDataGrid;
